import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service5',
  templateUrl: './service5.component.html',
  styleUrls: ['./service5.component.css']
})
export class Service5Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
